import styled, { keyframes } from "styled-components";
import { ReactComponent as SpinnerIcon } from "@/assets/icons/spinner.svg";
import { FC } from "react";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const ContentSpinnerHolder = styled.div`
  text-align: center;
  margin: 150px 0;
`;

const Spinner = styled(SpinnerIcon)`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  margin-right: 8px;
  animation: ${spin} 1s linear infinite;
  circle {
    opacity: 0.25;
  }
  path {
    opacity: 0.75;
  }
`;

interface Props {
  className?: string;
}

const ContentSpinner: FC<Props> = ({ className }) => {
  return (
    <ContentSpinnerHolder className={className}>
      <Spinner />
    </ContentSpinnerHolder>
  );
};

export default ContentSpinner;
